import { Col, Divider, Input, Row } from 'antd';
import { defaultImage } from 'assets/images';
import { OrderStar } from 'assets/svg';
import { useUser } from 'contexts/User';
import React from 'react';
import formatCurrencyVND from 'utils/formatCurrencyVND';

interface IProps {
  key: any;
  record: any;
  setIsModalVisible: (data: boolean) => void;
  setCart_register_detail: (data: any) => void;
  setDataDelete: (data: any) => void;
  setModalConfirmDelete: (data: boolean) => void;
  ChangeValueMin: (event: any, record: any) => void;
  ChangeValueMax: (event: any, record: any) => void;
}

export default function CartProductItem(props: IProps) {
  const {
    key,
    record,
    setIsModalVisible,
    setCart_register_detail,
    setDataDelete,
    setModalConfirmDelete,
    ChangeValueMax,
    ChangeValueMin,
  } = props;
  const { user } = useUser();
  return (
    <Row key={key}>
      <Col span={4} className="flex items-center justify-center">
        <img
          className="rounded-lg"
          width="80px"
          height="80px"
          src={record?.image_default || defaultImage}
          alt=""
        />
      </Col>

      <Col span={14} className="border-r-2 border-l-2 border-dashed px-2">
        <Row className="font-bold text-base pt-2">
          {record?.tvv_full_name || '-'} | {record?.tvv_job_title || '-'}
        </Row>
        <Row className="text-base pt-2 text-neutral-40">
          {record?.ma_mau || '-'}
        </Row>
        <Row className="text-base py-2 font-bold text-primary-50">
          {record?.ten_mau || '-'}
        </Row>
        <Row
          justify="space-between"
          className="text-base border-b-2 border-dashed pb-4"
        >
          <Col>
            {' '}
            Giá vốn:{' '}
            <span className="text-secondary-50 font-bold">
              {formatCurrencyVND(record?.cost_price) || '-'}
            </span>
          </Col>
          <Col>{record?.color || '-'}</Col>
        </Row>
        {/* --------------------------------- */}
        <Row className="my-2" gutter={35} justify="start">
          <Col span={1}>
            <OrderStar />
          </Col>
          <Col span={6}>
            <Row className="text-sm text-neutral-50">Đánh giá 3 tiêu chí</Row>
            <Row className="text-sm">{record?.kldg_3tc || '-'}</Row>
          </Col>
          {/* ----------------------------- */}
          <Col span={1}>
            <OrderStar />
          </Col>
          <Col span={6}>
            <Row className="text-sm text-neutral-50">Doanh thu 6 tháng</Row>
            <Row className="text-sm">{record?.doanhthu_6th || '-'}</Row>
          </Col>
          {/* ----------------------------- */}
          <Col span={1}>
            <OrderStar />
          </Col>
          <Col span={6}>
            <Row className="text-sm text-neutral-50">Tồn hiện tại</Row>
            <Row className="text-sm">{record?.tongsl_ton || '-'}</Row>
          </Col>
        </Row>
        {/* ----------------------------------*/}
        <Row className="border-t-2 border-dashed pt-4">
          <Col
            onClick={() => {
              setIsModalVisible(true);
              setCart_register_detail(record);
            }}
            className="text-primary-50 font-bold cursor-pointer"
            span={7}
          >
            Xem chi tiết {'>'}
          </Col>
          <Col span={1}>
            <Divider type="vertical" />
          </Col>
          {/* <Col
            onClick={() => {
              console.log('test');
            }}
            className="text-primary-50 font-bold cursor-pointer"
            span={7}
          >
            Lịch sử đặt hàng
          </Col> */}
          <Col span={1}>
            <Divider type="vertical" />
          </Col>
          {/* {record?.order_status != 2 &&
            record?.order_status != 4 &&
            !user?.role.includes('asm') && (
              <Col
                onClick={() => {
                  setDataDelete({
                    cart_order_cht_id: record?.cart_order_cht_id,
                    list_cart_order_cht_dt_ids: [record?.cart_order_cht_dt_id],
                  });
                  setModalConfirmDelete(true);
                }}
                className="text-red-500 font-bold cursor-pointer"
                span={7}
              >
                Xoá
              </Col>
            )} */}
        </Row>
      </Col>

      <Col span={6} className="pl-2">
        <Row
          justify={'space-between'}
          className="border-b-2 border-dashed pb-2 mb-2"
        >
          <Col>Số ni</Col>
          <Col className="font-bold">{record?.ni_sanpham || '-'}</Col>{' '}
        </Row>
        <Row
          justify={'space-between'}
          className="border-b-2 border-dashed pb-2 mb-2"
        >
          <Col>Đăng ký cũ</Col>
          <Col className="font-bold">
            {record?.old_order_min || '0'} - {record?.old_order_max || '0'}
          </Col>{' '}
        </Row>

        <Row
          justify="space-between"
          className="border-b-2 border-dashed mb-2 pb-2"
        >
          <Col span={12}>Đăng ký hiện tại</Col>
          <Col span={4}>
            <Input
              style={{
                height: '28px',
                width: '100%',
                borderRadius: '5px',
                padding: '8px',
                textAlign: 'center',
              }}
              // disabled={
              //   user?.role.includes('cua_hang_truong') &&
              //   record?.order_status != 2 &&
              //   record?.order_status != 4
              //     ? false
              //     : true
              // }
              disabled={true}
              key={record?.cart_register_detail_id}
              onBlur={(event) => ChangeValueMin(event, record)}
              onPressEnter={(event) => ChangeValueMin(event, record)}
              defaultValue={record?.order_min}
            />
          </Col>
          <Col span={4}>
            <Input
              style={{
                height: '28px',
                width: '100%',
                borderRadius: '5px',
                padding: '8px',
                textAlign: 'center',
              }}
              // disabled={
              //   user?.role.includes('cua_hang_truong') &&
              //   record?.order_status != 2 &&
              //   record?.order_status != 4
              //     ? false
              //     : true
              // }
              disabled={true}
              key={record?.cart_register_detail_id}
              onBlur={(event) => ChangeValueMax(event, record)}
              onPressEnter={(event) => ChangeValueMax(event, record)}
              defaultValue={record?.order_max}
            />
          </Col>
        </Row>

        <Row justify={'end'}>Vốn tồn tạm tính</Row>
        <Row justify={'end'} className="text-base text-secondary-50 font-bold">
          {formatCurrencyVND(record?.order_min * record?.cost_price) || '-'} -{' '}
          {formatCurrencyVND(record?.order_max * record?.cost_price) || '-'}
        </Row>
      </Col>
    </Row>
  );
}
